export default __webpack_public_path__ + "static/media/MerchStoreResponsiveSmall.2eb0222d.png";